import { useState } from 'react';

import { CasRenderDate, CasTable } from 'src/compass/shared/components';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import getCasTableCellValue from 'src/compass/shared/components/CasTable/getCasTableCellValue';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';

import RvwUploadDialog from '../../shared/ClaimDetails/RvwUploadDialog';
import ClaimDetailsDialog from '../../shared/ClaimDetails/ClaimDetailsDialog';

export default function PendingTab() {
  const [dialogRow, setDialogRow] = useState<any>(null);
  const [reloadTable, setReloadTable] = useState<Date | null>(null);
  const [openClaimDetails, setOpenClaimDetails] = useState<boolean>(false);

  return (
    <>
      <CasTable
        entity="Sce/Claims/RvwUpload/Pending"
        update={reloadTable}
        includeExport={false}
        columns={[
          { field: 'dateCreated', label: 'Date Requested', render: CasRenderDate },
          { field: 'requestType' },
          {
            field: 'insuredName',
            render: ({ row, column }: ICasRenderCellProps) => (
              <CasLink onClick={() => setDialogRow(row)}>
                {getCasTableCellValue({ row, column })}
              </CasLink>
            ),
          },
          { field: 'email' },
        ]}
      />
      {dialogRow &&
        (openClaimDetails ? (
          <ClaimDetailsDialog
            id={dialogRow.endorsementId}
            onClose={() => {
              setDialogRow(null);
              setOpenClaimDetails(false);
            }}
          />
        ) : (
          <RvwUploadDialog
            id={dialogRow.id}
            onClose={() => setDialogRow(null)}
            onUpdated={() => setReloadTable(new Date())}
            onViewClaimDetails={() => setOpenClaimDetails(true)}
          />
        ))}
    </>
  );
}
